import React from 'react';
import { node } from 'prop-types';
import { Box } from '@mui/material';

const DocumentList = ({ children }) => (
  <Box sx={{ width: '100%', paddingTop: '20px' }}>{children}</Box>
);

DocumentList.propTypes = {
  children: node.isRequired,
};

export default DocumentList;
